import { Button, Dialog } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";

interface ChangeGroupDialogProps {
    show: boolean;
    userName?: string;
    onConfirm: () => void;
    onCancel: () => void;
}

const ChangeGroupDialog = ({ show, userName, onConfirm, onCancel }: ChangeGroupDialogProps) => {
    const intl = useIntl();

    return (
        <Dialog
            show={show}
            title={(
                <>
                    <span className="rioglyph rioglyph-warning-sign margin-right-10 text-color-warning" />
                    <span>{intl.formatMessage({ id: "intl-msg:support.changeGroupDialog.title" })}</span>
                </>
            )}
            body={intl.formatMessage({ id: "intl-msg:support.changeGroupDialog.body" }, { userName })}
            bsSize={Dialog.SIZE_SM}
            onClose={onCancel}
            footer={(
                <div className="display-flex justify-content-end">
                    <Button bsStyle="default" className="margin-right-10" onClick={onCancel}>
                        {intl.formatMessage({ id: "intl-msg:support.changeGroupDialog.cancel" })}
                    </Button>
                    <Button bsStyle="primary" onClick={onConfirm}>
                        {intl.formatMessage({ id: "intl-msg:support.changeGroupDialog.confirm" })}
                    </Button>
                </div>
            )}
        />
    );
};

export default ChangeGroupDialog;
